import { Button } from "@/components/ui/button";
import { BookOpen, /* ClipboardCopy, */ FileText, Highlighter, Lightbulb, MessageSquarePlus } from "lucide-react";

interface Props {
  selectedText: string;
  position: { x: number; y: number };
  onAppendToAbstract: (text: string) => void;
  onAddAsChunk: (text: string) => void;
  onExplain?: (text: string) => void;
  onStashEvidence?: (text: string) => void;
  onHighlight?: (text: string) => void;
  onDismiss: () => void;
}

export function PdfSelectionToolbar({
  selectedText,
  position,
  onAppendToAbstract,
  onAddAsChunk,
  onExplain,
  onStashEvidence,
  onHighlight,
  onDismiss,
}: Props) {
  /* Copy action hidden for now — re-enable by uncommenting Copy button below
  const handleCopy = () => {
    navigator.clipboard.writeText(selectedText);
    onDismiss();
  };
  */

  return (
    <div
      className="absolute z-50 flex items-center gap-1 rounded-md border bg-popover p-1 shadow-md"
      style={{ left: position.x, top: position.y }}
      data-testid="pdf-selection-toolbar"
    >
      {onHighlight && (
        <button
          onClick={() => { try { onHighlight(selectedText); } finally { onDismiss(); window.getSelection()?.removeAllRanges(); } }}
          className="flex items-center gap-1 px-2 py-1 text-xs rounded hover:bg-pink-500/20 text-pink-300 font-medium"
          title="Save as highlight"
        >
          <Highlighter size={14} />
          Highlight
        </button>
      )}
      {onStashEvidence && (
        <button
          onClick={() => {
            onStashEvidence(selectedText);
            onDismiss();
          }}
          className="flex items-center gap-1 px-2 py-1 text-xs rounded hover:bg-violet-500/20 text-violet-300 font-medium"
          title="Save as evidence for a claim"
        >
          <FileText size={14} />
          Evidence
        </button>
      )}
      <Button
        variant="ghost"
        size="xs"
        onClick={() => {
          onAppendToAbstract(selectedText);
          onDismiss();
        }}
        title="Add to concept abstract"
      >
        <BookOpen className="mr-1 size-3" />
        <span className="text-xs">Abstract</span>
      </Button>
      <Button
        variant="ghost"
        size="xs"
        onClick={() => {
          onAddAsChunk(selectedText);
          onDismiss();
        }}
        title="Save to Corpus Chat"
      >
        <MessageSquarePlus className="mr-1 size-3" />
        <span className="text-xs">Corpus Chat</span>
      </Button>
      {onExplain && (
        <Button
          variant="ghost"
          size="xs"
          onClick={() => {
            onExplain(selectedText);
            onDismiss();
          }}
          title="Explain this passage"
        >
          <Lightbulb className="mr-1 size-3" />
          <span className="text-xs">Explain</span>
        </Button>
      )}
      {/* Copy action — hidden for now, machinery preserved via handleCopy */}
    </div>
  );
}
